export enum enumScheduleStatus {
  RICHIESTA = 1,
  ACCETTATA = 2,
  ANNULLATA = 3,
  CHIUSA = 4,
}
